export default "__VITE_ASSET__CIYyrYFk__"